<script lang="ts">
	import type { Tokens } from 'marked';
	import { getMarkdownSafetyContext } from '../../utils/getMarkdownSafetyContext/getMarkdownSafetyContext';
	import { isSafeMarkdownUrl } from '../../utils/isSafeMarkdownUrl/isSafeMarkdownUrl';

	interface Props {
		token: Tokens.Image;
	}

	let { token }: Props = $props();

	const safety = getMarkdownSafetyContext();

	let shouldRender = $derived(!safety?.untrusted || isSafeMarkdownUrl(token.href, 'image'));
</script>

{#if shouldRender}
	<img src={token.href} title={token.title} alt={token.text} />
{/if}
